exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ":root{--basal:#19a0d7;--bolus:#7cd0f0;--bolus--interrupted:#ff8b7c;--bolus--ride:#107ea8;--bolus--undelivered:#bcecfa;--carbs:#ffd382;--collapsible--border:#ededed;--table-stripe--light:#f7f7f7;--table-stripe--dark:#ececec;--trends--light:#d0d0d0;--trends--light--faded:#f0f0f0;--trends--dark:#bcbcbc;--trends--dark--faded:#e3e3e3;--axis-tick:#e7e7e7;--bkgrnd:#f8f8f8;--bkgrnd-lines:#e7e7e7;--bkgrnd-white:#fff;--tooltip-title-bg:#eaeaee;--chrome:#989897;--text-medium-contrast:#727375;--text-high-contrast:#281946;--text-black:#000;--bg-low:#ff8b7c;--bg-target:#76d3a6;--bg-high:#bb9ae7;--text-hover:#00d3d9;--blue-green-light:#12d3d8;--gray-dark:#989897;--white:#fff}", ""]);

// exports
exports.locals = {
	"basal": "#19A0D7",
	"low": "#FF8B7C",
	"target": "#76D3A6",
	"high": "#BB9AE7"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!./~/postcss-loader!./src/styles/colors.css
 ** module id = 64
 ** module chunks = 0
 **/